


import React, { useState } from "react";
import "../../assets/css/Login.css";
import ApiUrl from "../Environment/ApiUrl";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async () => {
    // Clear previous errors
    setError("");

    // Validate inputs
    if (!username.trim()) {
      setError("Please enter username");
      return;
    }

    if (!password.trim()) {
      setError("Please enter password");
      return;
    }

    setIsLoading(true);

    try {
      console.log("Attempting login with:", { username, password });

      const response = await axios.post(`${ApiUrl}/Api/login.php`, {
        username,
        password,
      });

      console.log("Login response:", response.data);

      const data = response.data;
      if (data.status === "success") {
        // Store user info in localStorage
        localStorage.setItem("token", data.token);
        localStorage.setItem("username", data.user_id);
        localStorage.setItem("role", data.role);

        // ✅ ADD THIS - Store complete user object
        localStorage.setItem("user", JSON.stringify({
          id: data.id,                    // Numeric ID from response
          user_id: data.user_id,          // User ID like "M-001", "A-001", etc.
          name: data.name || data.username, // User's name
          role: data.role,                // Role: "Manager", "Employee", "admin"
          manager_id: data.manager_id || null // Manager ID if employee
        }));

        // Check daily rates
        try {
          const ratesResponse = await axios.get(
            `${ApiUrl}/Api/daily_rates.php/current-date`
          );
          // ... rest of your code
          const ratesData = ratesResponse.data;

          if (
            ratesData.status === true &&
            ratesData.current_date === ratesData.data.date
          ) {
            // Dates match, navigate to dashboard
            navigate("/dashboard");
          } else {
            // Dates don't match, navigate to daily rates popup
            navigate("/dailyrates-popup");
          }
        } catch (ratesError) {
          console.error("Daily rates error:", ratesError);
          // On rates API error, navigate to daily rates popup as fallback
          setError("Failed to fetch daily rates. Redirecting to rates update.");
          navigate("/dailyrates-popup");
        }
      } else {
        // Handle error message from server
        setError(data.message || "Login failed. Please try again.");
      }
    } catch (err) {
      console.error("Login error:", err);

      // Handle different types of errors
      if (err.response) {
        // The server responded with an error status
        const errorMsg =
          err.response.data && err.response.data.message
            ? err.response.data.message
            : "Login failed. Please check your credentials.";
        setError(errorMsg);
      } else if (err.request) {
        // The request was made but no response was received
        setError("No response from server. Please check your connection.");
      } else {
        // Something else caused the error
        setError("An error occurred. Please try again later.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Handle Enter key press
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <>
      <div className="login">
        <div
          className="marble-texture"
          style={{
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "100vh",
          }}
        >
          <div className="content">
            <div className="login-form-container">
              <div className="login-form">
                <div className="text-center mb-4">
                  <div
                    className="logoimg" ali
                    style={{
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      height: "120px",
                      width: "140px",
                      margin: "0 auto",
                    }}
                  ></div>
                </div>
                <h4 className="form-title">Username</h4>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  onKeyDown={handleKeyDown}
                />

                <h4 className="form-title mt-4">Password</h4>
                <div className="password-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    placeholder="Enter Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                  <span
                    className="password-toggle"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? (
                      <i className="bi bi-eye-slash"></i>
                    ) : (
                      <i className="bi bi-eye"></i>
                    )}
                  </span>
                </div>

                <button
                  className="btn btn-login"
                  onClick={handleLogin}
                  disabled={isLoading}
                >
                  {isLoading ? "Logging in..." : "Login"}
                </button>

                {error && (
                  <div className="alert alert-danger mt-2" role="alert">
                    {error}
                  </div>
                )}
              </div>
            </div>
            <div className="ring-container">
              <div className="reflection"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
